import { useCallbackRef } from './useCallbackRef';

/** @description Хук для получения константы, которая не будет пересоздаваться при каждом рендере */
export function useConstant(getConstant) {
  return useCallbackRef(getConstant).current;
}